<template>
  
  <button v-if="$isSimavet()" :id="_uid" class="ui mini tertiary grey right floated button" :class="{ loading }" @click="toggleBookmark()">
    <i class="star icon" :class="{ outline: !!bookmark }"></i> 
    {{ !bookmark ? 'Adicionar aos favoritos' : 'Remover dos favoritos' }}    
  </button>

</template>

<script>

  import BookmarkService from "@/services/bookmark-service"

  export default {
    
    name: "BookmarkButton",

    data() {
      return {
        loading: false,
        bookmark: null,
        service: new BookmarkService(),
      }
    },

    props: {
      label: { type: String, required: true },
    },

    mounted() {

      for (let bookmark of this.$store.state.auth.bookmarks) {
        if (bookmark.route == this.$route.path)
          this.bookmark = this.$cloneObject(bookmark)
      }
    },

    methods: {

      async toggleBookmark() {

        this.loading = true
        
        try {

          if (this.bookmark) {

            await this.service.remove(this.bookmark)

            this.bookmark = null

          } else {

            this.bookmark = await this.service.create({
              label: this.label,
              route: this.$route.path,
              userId: this.$store.state.auth.user.id,
            })
          }

          await this.service.loadCurrentUserBookmarks()

          $(`#${this._uid}`).blur()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      }
    },
  }

</script>